import request from '../utils/axios'

const getTasksList = async () => {
  return await request.get('/task/list')
}

const newTask = async () => {
  return await request.post('/task/')
}

const getTaskDetail = async (id) => {
  return await request.get(`/task/${id}`)
}
const setTaskRead = async (id) => {
  return await request.post(`/task/${id}/read`)
}
const getRandomWord = async () => {
  return await request.get('/keyword/random')
}

const getHotTopic = async () => {
  return await request.get('/keyword/hot')
}

const getHotTopicByName = async (name) => {
  return await request.get(`/keyword/hot/${name}`)
}

const updateTask = async (id, data) => {
  return await request.post(`/task/${id}/update`, data)
}

const taskRename = async ({ id, name }) => {
  return await request.post(`/task/${id}/rename`, {
    name: name
  })
}

const taskDelete = async (id) => {
  return await request.post(`/task/${id}/delete`)
}

const taskClone = (id) => {
  return request.post(`/task/${id}/clone`)
}

const taskSave = (task_id, key, params) => {
  return request.post(`/task/${task_id}/${key}/save`, params)
}
const inspirationUpdate = (task_id, key, params) => {
  return request.post(`/task/${task_id}/${key}/update`, params)
}

const batchDelete = (ids) => {
  return request.post('/task/batch_delete', { id_list: ids })
}

const evaluate = (task_id, key, params) => {
  return request.post(`/task/${task_id}/${key}/evaluate`, params)
}

const eventTracking = (params) => {
  return request.post('/event_tracking', params)
}

const saveFavorite = ({ task_id, key }) => {
  return request.post(`/task/${task_id}/${key}/favorite`)
}

const getFavoriteList = (params) => {
  return request.get('/favorite/list', { params })
}

const PostRename = async ({ favorite_id, name }) => {
  return await request.post(`/favorite/${favorite_id}/rename`, {
    name: name
  })
}

const deleteFavorite = async ({ favorite_id }) => {
  return await request.post(`/favorite/${favorite_id}/delete`)
}

const batchDeleteFavorite = async (params) => {
  return await request.post(`/favorite/batch_delete`, params)
}

const getFavoriteDetail = async (favorite_id) => {
  return await request.get(`/favorite/${favorite_id}`)
}

const postUpdateFavorite = async (favorite_id, params) => {
  return await request.post(`/favorite/${favorite_id}/update`, params)
}

const getGenerated = async (task_id, params) => {
  return await request.get(`/task/${task_id}/generated`, { params })
}

const postGenerated = async (data) => {
  return await request.get(`/image/uploads`, data)
}

const getImageList = async (params) => {
  return await request.get(`/image/list`, { params })
}

// 获取详情
const getImageDetail = async (image_id) => {
  return await request.get(`/image/${image_id}`)
}

// 批量上传
const postImageUploads = (data) => {
  return request({
    headers: { 'Content-Type': 'multipart/form-data' },
    url: `/image/uploads`,
    method: 'post',
    data: data
  })
}

// 更新图片蒙版
const postImageUpdate = async ({ image_id, file }) => {
  return request({
    headers: { 'Content-Type': 'multipart/form-data' },
    url: `/image/${image_id}/update`,
    method: 'post',
    data: file
  })
}

// 一键清除图片
const postImageDelete = async () => {
  return await request.post(`/image/delete/all`)
}

// 删除单张图片
const postImageDeleteOne = async (image_id) => {
  return await request.post(`/image/${image_id}/delete`)
}

// 下载图片
const postImageDownload = async (image_id) => {
  return await request.get(`/image/${image_id}/download`)
}

// 批量修改尺寸
const postResize = async (data) => {
  return await request.post(`/image/batch/resize`, data)
}

// 获取个人统计数据
const getImageStatistics = async () => {
  return await request.get('/image/summary/personal')
}

// 获取清除背景的图片
const postImageRomoveBackground = async (data) => {
  return await request.post('/image/remove_background', data)
}

const getBatchImageDownload = async (ids, namesMap) => {
  const params = {
    ids: ids.join(','),
    namesMap: JSON.stringify(namesMap)
  }
  return await request({
    url: '/image/batch/download',
    method: 'get',
    params
  })
}

/* 任务统计**/
const getWholeData = async (params) => {
  return await request({
    url: '/admin/statistics/data_all',
    method: 'get',
    params,
    showToast: true
  })
}

const getPersonalData = async (params) => {
  return await request({
    url: '/admin/statistics/data_single',
    method: 'get',
    params,
    showToast: true
  })
}

const getAllPersonal = async (params) => {
  return await request({
    url: '/admin/person/open_id',
    method: 'get',
    params,
    showToast: true
  })
}

/* 任务统计**/

export {
  getTasksList,
  newTask,
  getTaskDetail,
  getRandomWord,
  getHotTopic,
  getHotTopicByName,
  updateTask,
  taskRename,
  taskDelete,
  taskClone,
  taskSave,
  inspirationUpdate,
  setTaskRead,
  batchDelete,
  evaluate,
  eventTracking,
  saveFavorite,
  getFavoriteList,
  PostRename,
  deleteFavorite,
  batchDeleteFavorite,
  getFavoriteDetail,
  postUpdateFavorite,
  getGenerated,
  getImageList,
  getImageDetail,
  postImageUploads,
  postImageDelete,
  postImageDeleteOne,
  postImageDownload,
  postImageUpdate,
  postResize,
  getImageStatistics,
  postImageRomoveBackground,
  getBatchImageDownload,
  getWholeData,
  getPersonalData,
  getAllPersonal
}
